import http from "@/http-common"
import { useQuery } from "@tanstack/vue-query"

const url = "tilanimikkeet"

export function useTilanimikeet() {
    const key = [url]
    
    const fetcher = async () => {
        const response = await http.get(url)
        return response.data
    }

    const { data: tilanimikkeet, error, isPending: loading } = useQuery({ 
        queryKey: key, 
        queryFn: fetcher,
        refetchOnWindowFocus: false, // Disable refetching when the window regains focus to avoid unnecessary network requests.
        refetchOnMount: false, // Disable refetching on component mount as the data is assumed to be static or already fetched.
        refetchInterval: 0, // Disable periodic refetching since real-time updates are not required for this data.
    })

    return {
        tilanimikkeet,
        error,
        loading,
    }
}
